import { createContext, useContext, useCallback } from 'react';
import { toast } from 'sonner';

const NotificationContext = createContext();

export const useNotifications = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error('useNotifications must be used within NotificationProvider');
  }
  return context;
};

export function NotificationProvider({ children }) {
  const showSuccess = useCallback((message, description) => {
    toast.success(message, {
      description: description,
      duration: 3000,
    });
  }, []);

  const showError = useCallback((message, description) => {
    toast.error(message, {
      description: description,
      duration: 5000,
    });
  }, []);

  const showInfo = useCallback((message, description) => {
    toast.info(message, {
      description: description,
      duration: 3000,
    });
  }, []);

  const showWarning = useCallback((message, description) => {
    toast.warning(message, {
      description: description,
      duration: 4000,
    });
  }, []);

  const showLoading = useCallback((message) => {
    return toast.loading(message);
  }, []);

  const dismiss = useCallback((toastId) => {
    toast.dismiss(toastId);
  }, []);

  const value = {
    showSuccess,
    showError,
    showInfo,
    showWarning,
    showLoading,
    dismiss
  };

  return (
    <NotificationContext.Provider value={value}>
      {children}
    </NotificationContext.Provider>
  );
}
